export default __webpack_public_path__ + "static/media/rose_00.2e9cde65.png";